<template>
    <div :id="'tab-' + name.toLowerCase().replace(/[\W_\s]/g, '')" class="tab-pane fade" :class="{ 'show active': isActive }" role="tabpanel">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            name: { 
                required: true 
            },

            selected: {
                default: false
            }
        },
        
        data() {
            return {
                isActive: false
            };
        },
        
        mounted() {
            this.isActive = this.selected;
        }
    }
</script>